import { render, staticRenderFns } from "./BookAppointmentNew.vue?vue&type=template&id=6a47b7b1&"
import script from "./BookAppointmentNew.vue?vue&type=script&lang=ts&"
export * from "./BookAppointmentNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports